/**
 * Best Sellers Popup JavaScript
 * Manages popup display and product filtering based on cart contents
 */

(function() {
  'use strict';

  // Cache DOM elements
  const popup = document.getElementById('best-sellers-popup');
  if (!popup) {
    console.error('Best Sellers Popup: Popup element not found! Make sure the snippet is included.');
    return;
  }
  
  console.log('Best Sellers Popup: Found popup element', popup);

  const overlay = popup.querySelector('.best-sellers-popup__overlay');
  const closeButton = popup.querySelector('.best-sellers-popup__close');
  const productsContainer = popup.querySelector('.best-sellers-popup__products');
  const productItems = popup.querySelectorAll('.best-sellers-popup__product-item');
  
  console.log('Best Sellers Popup: Found', productItems.length, 'product items');

  // State
  let isOpen = false;
  let cartItems = [];

  /**
   * Initialize popup functionality
   */
  function init() {
    console.log('Best Sellers Popup: Initializing...');
    
    // Add event listeners
    attachEventListeners();
    
    // Fetch initial cart state
    updateCartItems();
    
    console.log('Best Sellers Popup: Initialized successfully');
  }

  /**
   * Attach event listeners
   */
  function attachEventListeners() {
    // Close button
    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }
    
    // Overlay click to close
    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }
    
    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closePopup();
      }
    });

    // Listen for cart updates - Dawn uses PubSub pattern
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        updateCartItems();
        
        // Show popup when cart is updated from main product page
        console.log('Best Sellers Popup: Cart update event', event);
        if (event && event.source === 'product-form') {
          const mainProduct = document.querySelector('.product');
          const mainProductSection = document.querySelector('main[id*="MainProduct"]');
          console.log('Best Sellers Popup: Checking to show popup from cart update', !!mainProduct, !!mainProductSection, !isOpen);
          if (mainProduct && mainProductSection && !isOpen) {
            openPopup();
          }
        }
      });
    }
    
    // Alternative: Watch for cart drawer opening
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      console.log('Best Sellers Popup: Found cart drawer element');
      
      // Use MutationObserver to watch for cart drawer opening
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isActive = cartDrawer.classList.contains('active');
            console.log('Best Sellers Popup: Cart drawer active?', isActive);
            
            if (isActive && !isOpen) {
              // Check if we're on a product page
              const isProductPage = window.location.pathname.includes('/products/');
              console.log('Best Sellers Popup: Is product page?', isProductPage, 'Path:', window.location.pathname);
              
              if (isProductPage) {
                console.log('Best Sellers Popup: Triggering popup from cart drawer open');
                setTimeout(() => {
                  updateCartItems().then(() => {
                    openPopup();
                  });
                }, 500); // Wait for cart drawer animation
              }
            }
          }
        });
      });
      
      observer.observe(cartDrawer, { attributes: true });
    }
  }

  /**
   * Open the popup
   */
  function openPopup() {
    console.log('Best Sellers Popup: openPopup called, isOpen =', isOpen);
    if (isOpen) return;
    
    isOpen = true;
    popup.classList.add('is-active');
    document.body.classList.add('best-sellers-popup-open');
    
    console.log('Best Sellers Popup: Popup opened, classes added');
    
    // Set focus to close button for accessibility
    if (closeButton) {
      closeButton.focus();
    }
    
    // Filter products based on cart contents
    filterProducts();
  }
  
  // Add global function for testing
  window.testBestSellersPopup = function() {
    console.log('Testing Best Sellers Popup...');
    console.log('Popup element exists?', !!popup);
    console.log('Popup element:', popup);
    console.log('Current classes:', popup.className);
    console.log('Current display:', window.getComputedStyle(popup).display);
    
    updateCartItems().then(() => {
      openPopup();
      
      // Check after attempting to open
      setTimeout(() => {
        console.log('After openPopup:');
        console.log('Classes:', popup.className);
        console.log('Display:', window.getComputedStyle(popup).display);
        console.log('Z-index:', window.getComputedStyle(popup).zIndex);
        console.log('Opacity:', window.getComputedStyle(popup).opacity);
      }, 100);
    });
  };

  /**
   * Close the popup
   */
  function closePopup() {
    if (!isOpen) return;
    
    isOpen = false;
    popup.classList.remove('is-active');
    document.body.classList.remove('best-sellers-popup-open');
    
    // Return focus to add to cart button
    const addToCartButton = document.querySelector('.product-form__submit');
    if (addToCartButton) {
      addToCartButton.focus();
    }
  }

  /**
   * Update cart items from Shopify Cart API
   */
  async function updateCartItems() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Extract product IDs from cart
      cartItems = cart.items.map(item => {
        // Get the product ID (not variant ID)
        return item.product_id;
      });
      
      // Store cart items in data attribute for reference
      if (productsContainer) {
        productsContainer.setAttribute('data-cart-items', cartItems.join(','));
      }
      
      return cartItems;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return [];
    }
  }

  /**
   * Filter products to hide those already in cart
   */
  function filterProducts() {
    if (!productItems.length) return;
    
    let visibleCount = 0;
    
    productItems.forEach(item => {
      const productId = parseInt(item.getAttribute('data-product-id'));
      
      if (cartItems.includes(productId)) {
        item.classList.add('is-hidden');
      } else {
        item.classList.remove('is-hidden');
        visibleCount++;
      }
    });
    
    // If all products are hidden, show a message
    if (visibleCount === 0 && productsContainer) {
      const emptyMessage = popup.querySelector('.best-sellers-popup__empty');
      if (!emptyMessage) {
        productsContainer.innerHTML = '<div class="best-sellers-popup__empty"><p>All best sellers are already in your cart!</p></div>';
      }
    }
  }

  /**
   * Handle visibility change to pause/resume any animations
   */
  document.addEventListener('visibilitychange', function() {
    if (document.hidden && isOpen) {
      // Could pause any animations here if needed
    }
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Wait a bit for PubSub to be available
    setTimeout(init, 100);
  }

})(); 